export enum rsrTabs {
  RATINGS = 'ratings',
  USERS = 'users',
}

export const tabNames = {
  ratings: {
    path: rsrTabs.RATINGS,
    name: 'ADMIN.RATINGS.TITLE',
  },
  users: {
    path: rsrTabs.USERS,
    name: 'ADMIN.USERS.TITLE',
  },
};
